<script setup lang="ts">
import { computed } from 'vue';

// Define props for the component
interface TruncatedTextProps {
  text: string;
  maxLength: number;
}

const props = defineProps<TruncatedTextProps>();

// Computed property to truncate the string
const truncatedText = computed(() => {
  return props.text.length > props.maxLength
    ? props.text.slice(0, props.maxLength) + '...'
    : props.text;
});
</script>

<template>
  <span>{{ truncatedText }}</span>
</template>

